var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29406_174)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6511 5.46512H5.46509V54.6512H54.6511V5.46512Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16279 7.55814H0V0H7.55814V1.16279H1.16279V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 7.55814H58.8372V1.16279H52.4419V0H60V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60H52.4419V58.8372H58.8372V52.4419H60V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55814 60H0V52.4419H1.16279V58.8372H7.55814V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29406_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6504 44H37.585C37.1464 44 36.7908 43.6444 36.7908 43.2058C36.7908 42.7671 37.1464 42.4115 37.585 42.4115H39.6504C41.1728 42.4115 42.4115 41.1729 42.4115 39.6504V20.3496C42.4115 18.8272 41.1729 17.5885 39.6504 17.5885H27.7232C27.2845 17.5885 26.929 17.2329 26.929 16.7942C26.929 16.3556 27.2845 16 27.7232 16H39.6504C42.0488 16 44 17.9512 44 20.3496V39.6504C44 42.0488 42.0488 44 39.6504 44ZM31.8426 44H20.3496C17.9512 44 16 42.0488 16 39.6504V20.3496C16 17.9512 17.9512 16 20.3496 16H22.137C22.5757 16 22.9313 16.3556 22.9313 16.7942C22.9313 17.2329 22.5757 17.5885 22.137 17.5885H20.3496C18.8272 17.5885 17.5885 18.8271 17.5885 20.3496V39.6504C17.5885 41.1728 18.8271 42.4115 20.3496 42.4115H31.8426C32.2812 42.4115 32.6368 42.7671 32.6368 43.2058C32.6368 43.6444 32.2812 44 31.8426 44Z",
    fill: "#63B6D4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23C26.3645 23 23 26.3645 23 30.5C23 34.6355 26.3645 38 30.5 38C34.6355 38 38 34.6355 38 30.5C38 26.3645 34.6355 23 30.5 23ZM36.4986 28H33.8129C33.577 26.4806 33.1286 25.21 32.5341 24.3306C34.3258 24.9229 35.7755 26.2715 36.4986 28ZM33 30.5C33 31.0239 32.9734 31.5235 32.9279 32H28.0721C28.0266 31.5235 28 31.0239 28 30.5C28 29.9761 28.0266 29.4765 28.0721 29H32.9277C32.9734 29.4765 33 29.9761 33 30.5ZM30.5 37C29.5973 37 28.6176 35.4409 28.2039 33H32.7961C32.3824 35.4409 31.4028 37 30.5 37ZM28.2039 28C28.6176 25.5591 29.5973 24 30.5 24C31.4028 24 32.3824 25.5591 32.7961 28H28.2039ZM28.4659 24.3306C27.8714 25.2101 27.4229 26.4806 27.1871 28H24.5014C25.2245 26.2715 26.6743 24.9229 28.4659 24.3306ZM24.1816 29H27.0668C27.0245 29.4826 27 29.9824 27 30.5C27 31.0176 27.0245 31.5174 27.0669 32H24.1816C24.0671 31.5175 24 31.017 24 30.5C24 29.983 24.0671 29.4825 24.1816 29ZM24.5014 33H27.187C27.4229 34.5194 27.8713 35.79 28.4658 36.6694C26.6741 36.0771 25.2245 34.7285 24.5014 33ZM32.5341 36.6694C33.1286 35.7899 33.5771 34.5194 33.8129 33H36.4985C35.7755 34.7285 34.3259 36.0771 32.5341 36.6694ZM36.8184 32H33.9331C33.9755 31.5174 34 31.0176 34 30.5C34 29.9824 33.9755 29.4826 33.9331 29H36.8182C36.9329 29.4825 36.9999 29.983 36.9999 30.5C36.9999 31.017 36.9329 31.5175 36.8184 32Z",
    fill: "#63B6D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5341 36.6694C33.1286 35.7899 33.5771 34.5194 33.8129 33H36.4985C35.7755 34.7285 34.3259 36.0771 32.5341 36.6694Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 37C29.5973 37 28.6176 35.4409 28.2039 33H32.7961C32.3824 35.4409 31.4028 37 30.5 37Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5014 33H27.187C27.4229 34.5194 27.8713 35.79 28.4658 36.6694C26.6741 36.0771 25.2245 34.7285 24.5014 33Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 30.5C33 31.0239 32.9734 31.5235 32.9279 32H28.0721C28.0266 31.5235 28 31.0239 28 30.5C28 29.9761 28.0266 29.4765 28.0721 29H32.9277C32.9734 29.4765 33 29.9761 33 30.5Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8184 32H33.9331C33.9755 31.5174 34 31.0176 34 30.5C34 29.9824 33.9755 29.4826 33.9331 29H36.8182C36.9329 29.4825 36.9999 29.983 36.9999 30.5C36.9999 31.017 36.9329 31.5175 36.8184 32Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1816 29H27.0668C27.0245 29.4826 27 29.9824 27 30.5C27 31.0176 27.0245 31.5174 27.0669 32H24.1816C24.0671 31.5175 24 31.017 24 30.5C24 29.983 24.0671 29.4825 24.1816 29Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4659 24.3306C27.8714 25.2101 27.4229 26.4806 27.1871 28H24.5014C25.2245 26.2715 26.6743 24.9229 28.4659 24.3306Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2039 28C28.6176 25.5591 29.5973 24 30.5 24C31.4028 24 32.3824 25.5591 32.7961 28H28.2039Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4986 28H33.8129C33.577 26.4806 33.1286 25.21 32.5341 24.3306C34.3258 24.9229 35.7755 26.2715 36.4986 28Z",
    fill: "#E9F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29406_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29406_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.796141516528996e033a80442f453798.svg";
export { ForwardRef as ReactComponent };